class ChargeTagAlreadyActiveException extends Error {
  constructor(message) {
    super(message);
    this.name = 'ChargeTagAlreadyActiveException';
  }
}

export default ChargeTagAlreadyActiveException;
